import { IconButton, Dialog, DialogTitle, DialogContent } from "@mui/material";
const ViewAppealResolved = (props) => {
  const { contents, showAppealResolved, setAppealResolved } = props;

  const onClose = () => {
    setAppealResolved(false);
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={showAppealResolved}
      fullWidth
    >
      <DialogTitle className="text-primary">
        <div className="d-flex flex-row justify-content-center">
          <span className="badge rounded-pill ap-badge-info  px-2 fw-bold">
            Appeal resolution.
          </span>
        </div>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent>{contents}</DialogContent>
    </Dialog>
  );
};

export default ViewAppealResolved;
